import { useParams, useLocation } from "wouter";
import { CampaignWizard } from "@/components/campaign-wizard/campaign-wizard";
import { useCampaignWizard } from "@/hooks/useCampaignWizard";
import { Skeleton } from "@/components/ui/skeleton";

export default function CampaignWizardPage() {
  const { brandId, campaignId } = useParams<{ brandId: string; campaignId?: string }>();
  const [, navigate] = useLocation();
  const wizard = useCampaignWizard(brandId, campaignId, navigate);

  if (wizard.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-4">
          <Skeleton className="h-8 w-48 mx-auto rounded-lg" />
          <Skeleton className="h-4 w-64 mx-auto rounded-lg" />
          <p className="text-sm text-muted-foreground mt-2">Loading campaign draft...</p>
        </div>
      </div>
    );
  }

  return <CampaignWizard wizard={wizard} brandId={brandId} />;
}
